import { useEffect } from 'react';
import amplitude from '../services/amplitude';

export const useAmplitudePaymentPageView = ({
  ticketId,
  plateNumber,
}: {
  ticketId: string;
  plateNumber: string;
}) => {
  useEffect(() => {
    if (ticketId == null || plateNumber == null) return;
    amplitude.paymentPageView({ ticketId, plateNumber });
  }, [ticketId, plateNumber]);
};
